












import { defineComponent, computed, useStore } from '@nuxtjs/composition-api'
import SectionNotifs from './sections/SectionNotifs.vue'
import HeaderNext from './next/HeaderNext.vue'
import { HeaderInfo } from '@/contracts/Settings'
import SectionNavigationNew from '@/components/Header/sections/SectionNavigationNew.vue'
import SectionNavigationNewV2 from '@/components/Header/sections/SectionNavigationNewV2.vue'
import { useFeatureFlag } from '@/composition/useFeatureFlag'
import { useRegistry } from '@/composition/useRegistry'

export default defineComponent({
  components: {
    HeaderNext,
    SectionNavigationNew,
    SectionNavigationNewV2,
    SectionNotifs,
  },
  setup() {
    const registry = useRegistry()

    const store = useStore()
    const { enabled: ffNewHeaderEnabled } = useFeatureFlag(
      'ff_redesigned_header'
    )
    const { enabled: ffHeaderNextEnabled } = useFeatureFlag(
      'ff_header_next_design'
    )
    const headerInfo = computed(
      () => store.getters['settings/headerInfo'] as HeaderInfo
    )
    const isNewDesign = computed(
      () => store.getters['settings/getHeaderFooterNewDesign']
    )

    return {
      headerInfo,
      ffNewHeaderEnabled,
      ffHeaderNextEnabled,
      isNewDesign,

      registry,
    }
  },
})
